import { render, staticRenderFns } from "./UserSettingsType.vue?vue&type=template&id=d61808b4&scoped=true"
import script from "./UserSettingsType.vue?vue&type=script&lang=js"
export * from "./UserSettingsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61808b4",
  null
  
)

export default component.exports